"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idSymbol = Symbol("id");
var lastId = 0;
function identify(instance) {
    var id = instance[idSymbol] = instance[idSymbol] || (++lastId).toString();
    return id;
}
exports.identify = identify;
